









import Vue from "vue";

import NotFound404 from "@/views/NotFound404.vue";
import PROJECT_BY_ROUTE_NAME from "@/graphql/projects/ProjectByRouteName.gql";

import {
  ProjectByRouteName,
  ProjectByRouteName_projects_edges_node
} from "@/api-types";

interface Project extends ProjectByRouteName_projects_edges_node {
  [key: string]: any;
}

export default Vue.extend({
  name: "Home",
  components: { NotFound404 },
  data() {
    return {
      project: null as Project | null
    };
  },
  apollo: {
    project: {
      query: PROJECT_BY_ROUTE_NAME,
      variables() {
        return { routeName: this.$route.params.projectRouteName };
      },
      update(data: ProjectByRouteName) {
        const edge = data.projects!.edges![0];
        return edge ? edge.node : null;
      }
    }
  }
});
